import React from 'react';
import { useQuery } from '@apollo/client';
import MobileLayout from '../components/Mobile/MobileLayout';
import MobileBanner from '../components/Mobile/MobileBanner';
import TrendingSection from '../components/Mobile/TrendingSection';
import InfiniteScrollSection from '../components/Mobile/InfiniteScrollSection';
import { GET_FEATURED_ADS, GET_TRENDING_ADS } from '../graphql/queries';

const MobileHome: React.FC = () => {
  const { data: featuredData } = useQuery(GET_FEATURED_ADS, {
    variables: { limit: 10 },
  });

  const { data: trendingData } = useQuery(GET_TRENDING_ADS, {
    variables: { limit: 10 },
  });

  return (
    <MobileLayout>
      {/* Hero Banner */}
      <MobileBanner />

      {/* Featured Section */}
      <TrendingSection
        ads={featuredData?.featuredAds || []}
        title="Featured"
      />

      {/* Trending Section */}
      <TrendingSection
        ads={trendingData?.trendingAds || []}
        title="Trending"
      />

      {/* Fresh Recommendations with Infinite Scroll */}
      <InfiniteScrollSection
        title="Fresh Recommendations"
        limit={10}
      />
    </MobileLayout>
  );
};

export default MobileHome;
